export default __webpack_public_path__ + "static/media/freedomdefined.6ee5518f.svg";